import { gql } from "@apollo/client";
import { VehicleCategoryValue, VehicleTypeValue } from "@app.automotus.io/components/common";
import { GET_CURRENTLY_REGISTERED_VEHICLES, COUNT_CURRENTLY_REGISTERED_VEHICLES } from "common/graphql";

export const BULK_REGISTER_VEHICLES = gql`
  mutation BulkRegisterVehicles($vehicles: [bulk_register_vehicle_input!]!) {
    bulkRegisterVehicles: bulk_register_vehicles(vehicles: $vehicles) {
      results {
        index
        status
        registeredVehicleId: registered_vehicle_id
        errorCode: error_code
      }
    }
  }
`;

export interface BulkRegisterVehicleInput {
  license_plate: string;
  state_code: string;
  vehicle_type: VehicleTypeValue;
  vehicle_category: VehicleCategoryValue;
  country_code: string;
  make?: string;
  model?: string;
  vehicle_year?: number;
}

export type BulkRegisterVehicleStatus = "success" | "error";

export interface BulkRegisterVehicleResult {
  index: number;
  status: BulkRegisterVehicleStatus;
  registeredVehicleId: string | null;
  errorCode: string | null;
}

export interface BulkRegisterVehiclesVars {
  vehicles: BulkRegisterVehicleInput[];
}

export interface BulkRegisterVehiclesData {
  bulkRegisterVehicles: {
    results: BulkRegisterVehicleResult[];
  };
}

export const BulkRegisterVehiclesRefetchQueries = [
  GET_CURRENTLY_REGISTERED_VEHICLES,
  COUNT_CURRENTLY_REGISTERED_VEHICLES,
];

export default BULK_REGISTER_VEHICLES;
